const cache: Record<string, unknown> = {};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const parseJSONScript = <T>(selector: string): T => {
    if (cache[selector] !== undefined) {
        return cache[selector] as T;
    }

    const script = parseUncachedJSONScript<T>(selector);

    cache[selector] = script;

    return script;
};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export const parseUncachedJSONScript = <T>(selector: string): T => {
    const scriptElementContent = document.querySelector<HTMLScriptElement>(selector)?.textContent;

    if (scriptElementContent === undefined) {
        throw new Error(`Could not find config JSON info at ${selector}.`);
    }

    return JSON.parse(scriptElementContent) as T;
};
